var quizQuestions = [
  {
      question: "What is Microsoft Azure Services?",
      answers: [
          {
              type: "Level 1",
              content: "Cloud computing"
          },
          {
              type: "Level 2",
              content: "Public cloud computing"
          },
          {
              type: "Level 3",
              content: "Microsoft Azure, formerly known as Windows Azure, is Microsoft's public cloud computing platform"
          }
      ]
  },
  {
      question: "What is powerBI",
      answers: [
          {
              type: "Level 1",
              content: "Business Intelligence platform by Microsoft"
          },
          {
              type: "Level 2",
              content: "Analysis tool"
          },
          {
              type: "Level 3",
              content: "Microsoft business analytics service."
          }
      ]
  },
  {
      question: "How do you rank your Azure knowledge",
      answers: [
          {
              type: "Level 1",
              content: "Have an idea: Level 1"
          },
          {
              type: "Level 2",
              content: "Know some form: Level 2"
          },
          {
              type: "Level 3",
              content: "Have knowledge of using it: Level 3"
          }
      ]
  },
  {
      question: "How do you rank your PowerBI knowledge",
      answers: [
          {
              type: "Level 1",
              content: "Have an idea: Level 1"
          },
          {
              type: "Level 2",
              content: "Know some form: Level 2"
          },
          {
              type: "Level 3",
              content: "Have knowledge of using it: Level 3"
          }
      ]
  },
  {
      question: "Do you need a licence for Microsoft Azure",
      answers: [
          {
              type: "Level 1",
              content: "No"
          },
          {
              type: "Level 2",
              content: "Yes"
          },
          {
              type: "Level 3",
              content: "Yes for paid version, No for free version"
          }
      ]
  },
  {
    question: "Do you need a licence for PowerBI",
    answers: [
        {
            type: "Level 1",
            content: "No"
        },
        {
            type: "Level 2",
            content: "Yes"
        },
        {
            type: "Level 3",
            content: "Yes for paid version, No for free version"
        }
    ]
},
{
    question: "What is azure mainly used for",
    answers: [
        {
            type: "Level 1",
            content: "Storage"
        },
        {
            type: "Level 2",
            content: "Analysis and Storage"
        },
        {
            type: "Level 3",
            content: "Cloud services including analysis, storage and networking"
        }
    ]
},
{
    question: "How do you use PowerBI to create visualisations",
    answers: [
        {
            type: "Level 1",
            content: "On Desktop "
        },
        {
            type: "Level 2",
            content: "On cloud and Desktop"
        },
        {
            type: "Level 3",
            content: "The platform is in two parts, desktop for creation and cloud for deployment"
        }
    ]
},
{
    question: "Is there a trial version for Azure",
    answers: [
        {
            type: "Level 1",
            content: "Yes"
        },
        {
            type: "Level 2",
            content: "Kind of"
        },
        {
            type: "Level 3",
            content: "No"
        }
    ]
},
{
    question: "Is there a trial version for PowerBI",
    answers: [
        {
            type: "Level 1",
            content: "Yes"
        },
        {
            type: "Level 2",
            content: "Kind of"
        },
        {
            type: "Level 3",
            content: "No"
        }
    ]
},
{
    question: "How are you billed on Azure",
    answers: [
        {
            type: "Level 1",
            content: "Once of payment"
        },
        {
            type: "Level 2",
            content: "Subscription"
        },
        {
            type: "Level 3",
            content: "Pay As you go"
        }
    ]
},
{
    question: "How are you billed on PowerBI",
    answers: [
        {
            type: "Level 1",
            content: "Once off paymeny"
        },
        {
            type: "Level 2",
            content: "Pay As you go"
        },
        {
            type: "Level 3",
            content: "Monthly fee"
        }
    ]
},
{
    question: "Does Azure comes on 365 licence",
    answers: [
        {
            type: "Level 1",
            content: "No"
        },
        {
            type: "Level 2",
            content: "Its part of the package"
        },
        {
            type: "Level 3",
            content: "Yes"
        }
    ]
},
{
    question: "Does powerBI comes on 365 license",
    answers: [
        {
            type: "Level 1",
            content: "No"
        },
        {
            type: "Level 2",
            content: "It can be included"
        },
        {
            type: "Level 3",
            content: "Yes"
        }
    ]
},
{
    question: "What are the solutions of Azure",
    answers: [
        {
            type: "Level 1",
            content: "IasA, PasA, SasA"
        },
        {
            type: "Level 2",
            content: "IasA, PasA, SaaS"
        },
        {
            type: "Level 3",
            content: "IaaS, PaaS, SaaS"
        }
    ]
},
{
    question: "What is the language used in PowerBI",
    answers: [
        {
            type: "Level 1",
            content: "MAX, RAS, XAD"
        },
        {
            type: "Level 2",
            content: "XAD, RAS, M"
        },
        {
            type: "Level 3",
            content: "DAX, M, R"
        }
    ]
},
{
    question: "In Azure, which of the following terms refers to making a service available with no downtime for an extended period?",
    answers: [
        {
            type: "Level 1",
            content: "Agility"
        },
        {
            type: "Level 2",
            content: "Fault Tolerance"
        },
        {
            type: "Level 3",
            content: "High Availability"
        }
    ]
},
{
    question: "The principal arrival of Power BI depended on the",
    answers: [
        {
            type: "Level 1",
            content: "Outlook"
        },
        {
            type: "Level 2",
            content: "Acess"
        },
        {
            type: "Level 3",
            content: "Excel"
        }
    ]
},
{
    question: "Which of the following can be used to manage governance across multiple Azure subscriptions?",
    answers: [
        {
            type: "Level 1",
            content: "Azure Initiatives"
        },
        {
            type: "Level 2",
            content: "Resource Groups"
        },
        {
            type: "Level 3",
            content: "Management Groups"
        }
    ]
},
{
    question: "What area do you go to change and reshape data in Power BI?",
    answers: [
        {
            type: "Level 1",
            content: "Data Transformation"
        },
        {
            type: "Level 2",
            content: "Data Modeling"
        },
        {
            type: "Level 3",
            content: "Data Editing"
        }
    ]
},
{
    question: "In Azure, which of the following is optimized for storing massive amounts of unstructured data, such as videos and images?",
    answers: [
        {
            type: "Level 1",
            content: "Queues"
        },
        {
            type: "Level 2",
            content: "Files"
        },
        {
            type: "Level 3",
            content: "Blobs"
        }
    ]
},
{
    question: "Which isn't a data compose in Power BI?",
    answers: [
        {
            type: "Level 1",
            content: "General"
        },
        {
            type: "Level 2",
            content: "Double"
        },
        {
            type: "Level 3",
            content: "Date"
        }
    ]
},
{
    question: "Azure Resource Manager templates use which format?",
    answers: [
        {
            type: "Level 1",
            content: "HTML"
        },
        {
            type: "Level 2",
            content: "XML"
        },
        {
            type: "Level 3",
            content: "JSON"
        }
    ]
},
{
    question: "How would you add a visual to a Dashboard in Power BI?",
    answers: [
        {
            type: "Level 1",
            content: "Stick"
        },
        {
            type: "Level 2",
            content: "Snap"
        },
        {
            type: "Level 3",
            content: "Embed"
        }
    ]
},
{
    question: "Which of the following could require both a password and a security question for full authentication?",
    answers: [
        {
            type: "Level 1",
            content: "Azure Firewall"
        },
        {
            type: "Level 2",
            content: "Application Gateway"
        },
        {
            type: "Level 3",
            content: "Multi-Factor Authentication"
        }
    ]
},
{
    question: "How would you add a visual to a Dashboard in Power BI?",
    answers: [
        {
            type: "Level 1",
            content: "Stick"
        },
        {
            type: "Level 2",
            content: "Snap"
        },
        {
            type: "Level 3",
            content: "Embed"
        }
    ]
},
{
    question: "Which of the following could require both a password and a security question for full authentication?",
    answers: [
        {
            type: "Level 1",
            content: "Azure Firewall"
        },
        {
            type: "Level 2",
            content: "Application Gateway"
        },
        {
            type: "Level 3",
            content: "Multi-Factor Authentication"
        }
    ]
},
{
    question: "Which Power BI visual is most fitting for estimating execution against an objective?",
    answers: [
        {
            type: "Level 1",
            content: "Entertainer"
        },
        {
            type: "Level 2",
            content: "Check"
        },
        {
            type: "Level 3",
            content: "Projectile"
        }
    ]
},
{
    question: "Which of the following lets you grant users only the rights they need to perform their jobs?",
    answers: [
        {
            type: "Level 1",
            content: "Azure Policy"
        },
        {
            type: "Level 2",
            content: "Compliance Manager"
        },
        {
            type: "Level 3",
            content: "Role-Based Access Control"
        }
    ]
},
{
    question: "In PowerBI, where do you discover the Q&A highlight?",
    answers: [
        {
            type: "Level 1",
            content: "By tapping on Modeling and Synonyms in Power BI work area"
        },
        {
            type: "Level 2",
            content: " At the highest point of a dashboard in the Power BI benefit"
        },
        {
            type: "Level 3",
            content: "At the highest point of a report in the Power BI benefit"
        }
    ]
},
{
    question: "Which of the following defines performance targets, like uptime, for an Azure product or service?",
    answers: [
        {
            type: "Level 1",
            content: "Usage Meters"
        },
        {
            type: "Level 2",
            content: "Support Plans"
        },
        {
            type: "Level 3",
            content: "Service Level Agreements"
        }
    ]
},
{
    question: "Power BI DAX context style is...?",
    answers: [
        {
            type: "Level 1",
            content: "Row Context"
        },
        {
            type: "Level 2",
            content: "Filter Context"
        },
        {
            type: "Level 3",
            content: "Both Row and Filter Context"
        }
    ]
},
{
    question: "Which of the following gives all Azure customers a chance to test the beta and other pre-release features?",
    answers: [
        {
            type: "Level 1",
            content: "Private Preview"
        },
        {
            type: "Level 2",
            content: "General availability"
        },
        {
            type: "Level 3",
            content: "Public Preview"
        }
    ]
},
{
    question: "Which of the accompanying is certainly not a substantial protection level for a Power BI information source?",
    answers: [
        {
            type: "Level 1",
            content: "Private"
        },
        {
            type: "Level 2",
            content: "Secured"
        },
        {
            type: "Level 3",
            content: "Open"
        }
    ]
},
{
    question: "You are running a virtual machine in a public cloud using IaaS. Which model correctly reflects how that resource is managed?",
    answers: [
        {
            type: "Level 1",
            content: "User management model"
        },
        {
            type: "Level 2",
            content: "Cloud user management model"
        },
        {
            type: "Level 3",
            content: "Shared responsibility model"
        }
    ]
},
{
    question: "Which language(s) can be utilized when planning a question in Power BI Desktop?",
    answers: [
        {
            type: "Level 1",
            content: "Python"
        },
        {
            type: "Level 2",
            content: "DAX"
        },
        {
            type: "Level 3",
            content: "SQL"
        }
    ]
},
{
    question: "You are building an application and want to focus on building, testing, and deploying. You do not want to worry about managing the underlying hardware or software. Which cloud service type is best for you?",
    answers: [
        {
            type: "Level 1",
            content: "Infrastructure as a Service (IaaS)"
        },
        {
            type: "Level 2",
            content: "Software as a Service (SaaS)"
        },
        {
            type: "Level 3",
            content: "Platform as a Service (PaaS)"
        }
    ]
},
{
    question: "When outlining an inquiry in Power BI Desktop to tidy up information, what task can be utilized to evacuate non-printable characters?",
    answers: [
        {
            type: "Level 1",
            content: "Clean"
        },
        {
            type: "Level 2",
            content: "Trim"
        },
        {
            type: "Level 3",
            content: "Disindect"
        }
    ]
},
{
    question: "You need to predict future behavior based on previous actions. Which product option should you eliminate as a candidate?",
    answers: [
        {
            type: "Level 1",
            content: "Azure Machine Learning"
        },
        {
            type: "Level 2",
            content: "Azure Cognitive Services"
        },
        {
            type: "Level 3",
            content: "Azure Bot Service "
        }
    ]
},
{
    question: "Which of the accompanying explanations are valid about information demonstrating in Power BI Desktop venture?",
    answers: [
        {
            type: "Level 1",
            content: "Inside a Power BI Desktop venture, all dimensional chain of command names must be exceptional"
        },
        {
            type: "Level 2",
            content: "Inside a Power BI Desktop venture, all question parameter names must be one of a kind."
        },
        {
            type: "Level 3",
            content: "Inside a Power BI Desktop venture, all measure names must be novel."
        }
    ]
}
];

export default quizQuestions;
